import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const MenuDotsIcon: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      {...props}
    >
      <path
        d="M5.83333 10.2751C5.83333 11.1955 5.08714 11.9417 4.16667 11.9417C3.24619 11.9417 2.5 11.1955 2.5 10.2751C2.5 9.35459 3.24619 8.6084 4.16667 8.6084C5.08714 8.6084 5.83333 9.35459 5.83333 10.2751Z"
        fill={props.fill || "currentColor" || "#747981"}
      />
      <path
        d="M11.6667 10.2751C11.6667 11.1955 10.9205 11.9417 10 11.9417C9.07952 11.9417 8.33333 11.1955 8.33333 10.2751C8.33333 9.35459 9.07952 8.6084 10 8.6084C10.9205 8.6084 11.6667 9.35459 11.6667 10.2751Z"
        fill={props.fill || "currentColor" || "#747981"}
      />
      <path
        d="M17.5 10.2751C17.5 11.1955 16.7538 11.9417 15.8333 11.9417C14.9129 11.9417 14.1667 11.1955 14.1667 10.2751C14.1667 9.35459 14.9129 8.6084 15.8333 8.6084C16.7538 8.6084 17.5 9.35459 17.5 10.2751Z"
        fill={props.fill || "currentColor" || "#747981"}
      />
    </svg>
  );
};

export default MenuDotsIcon;
